var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislikeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 26,
    rx: 5,
    fill: "#1B1C28"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1284_408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0418 14.2083L16.2085 20.5833C15.6449 20.5833 15.1044 20.3594 14.7059 19.9609C14.3074 19.5624 14.0835 19.0219 14.0835 18.4583V15.625H10.0743C9.86896 15.6273 9.66556 15.5849 9.4782 15.5009C9.29084 15.4168 9.124 15.293 8.98924 15.138C8.85449 14.983 8.75504 14.8006 8.69778 14.6034C8.64052 14.4062 8.62683 14.1988 8.65764 13.9958L9.63514 7.6208C9.68637 7.283 9.85796 6.97508 10.1183 6.7538C10.3786 6.53252 10.7102 6.41278 11.0518 6.41664H19.0418M19.0418 14.2083V6.41664M19.0418 14.2083H20.9331C21.3339 14.2154 21.7235 14.075 22.0277 13.8139C22.332 13.5527 22.5297 13.189 22.5835 12.7916V7.8333C22.5297 7.43597 22.332 7.0722 22.0277 6.81105C21.7235 6.5499 21.3339 6.40955 20.9331 6.41664H19.0418",
    stroke: "#2488FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1284_408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(7 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeIcon);
export default __webpack_public_path__ + "static/media/DislikeIcon.7234c7c69f4444e48eb57e2430dc2b3f.svg";
export { ForwardRef as ReactComponent };